import React from 'react';
import PropTypes from 'prop-types';
import fieldingpiechart from '../../../images/fielding-pie-chart.png';

const FieldingAngleComponent = ({ angle }) => {
    const rotationStyle = () => {
        switch (angle) {
        case 1:
            return { transform: 'rotate(270deg)' };
        case 2:
            return { transform: 'rotate(315deg)' };
        case 3:
            return { transform: 'rotate(0deg)' };
        case 4:
            return { transform: 'rotate(45deg)' };
        case 5:
            return { transform: 'rotate(90deg)' };
        case 6:
            return { transform: 'rotate(135deg)' };
        case 7:
            return { transform: 'rotate(180deg)' };
        case 8:
            return { transform: 'rotate(225deg)' };
        default:
            return { transform: 'rotate(0deg)' };
        }
    };

    return (
        <img style={rotationStyle()} src={fieldingpiechart} alt="Fielding Angle" />
    );
};

FieldingAngleComponent.propTypes = {
    angle: PropTypes.number,
};

export default FieldingAngleComponent;
